import { type IAdvancedRichText } from '../../inputs/rich-text-advanced/IAdvancedRichText.ts';
import { cachedStripHtml } from './cachedStripHtml.ts';

/**
 * Funzione che dato un AdvancedRichText ritorna la stringa corrispondente.
 * (e.g. utilizzata per ottenere la label di un widget)
 */
export function parseAdvancedRichTextToString(
  input: IAdvancedRichText | null | undefined,
  defaultValue = '',
): string {
  if (!input) return defaultValue;

  const htmlItems = input.filter(t => t.type === 'text' && t.text);

  if (htmlItems.length === 0) return defaultValue;

  const labelText = htmlItems
    .map(l => cachedStripHtml(l.text!))
    // Per ora rimuoviamo i riferimenti alle variabili e basta.
    .map(l => l.replace(/@([a-zA-Z0-9_-]+)/g, ''))
    .join('');

  return labelText;
}
